import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import { isBhooklyNativeServerApp, nativeSetBranding } from '@/lib/bhooklyNative'

function setLink(rel: string, href: string) {
  let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!link) {
    link = document.createElement('link')
    link.rel = rel
    document.head.appendChild(link)
  }
  link.href = href
}

function mimeFromUrl(u: string): string {
  const m = /^data:(image\/[a-z0-9.+-]+)/i.exec(u)
  return m ? m[1] : 'image/png'
}

// Re-brands the installable POS app with the tenant's logo + name once settings
// load (post-login), so the home-screen icon on a tablet is THEIR logo. Falls
// back to the bundled "B" icon / "Bhookly Retail" manifest when no logo is set.
export function PwaBranding() {
  const { data } = useQuery({
    queryKey: ['settings', 'all'],
    queryFn: () => apiClient.getAllSettings(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
  const d = data?.data as Record<string, unknown> | undefined
  const logo = typeof d?.['receipt_logo_url'] === 'string' ? (d['receipt_logo_url'] as string) : ''
  const name = typeof d?.['receipt_business_name'] === 'string' ? (d['receipt_business_name'] as string) : ''

  useEffect(() => {
    // Bhookly Server APK: push logo into the Android top bar + recents icon.
    if (isBhooklyNativeServerApp()) {
      nativeSetBranding(logo, name)
    }
    if (!logo) return
    setLink('apple-touch-icon', logo)
    setLink('icon', logo)
    const manifest = {
      name: name ? `${name} POS` : 'Bhookly Retail',
      short_name: name || 'POS',
      description: 'Point of sale, inventory and admin.',
      display: 'standalone',
      scope: '/',
      start_url: '/',
      theme_color: '#0f172a',
      background_color: '#0f172a',
      icons: [{ src: logo, sizes: 'any', type: mimeFromUrl(logo), purpose: 'any maskable' }],
    }
    const url = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' }))
    setLink('manifest', url)
    return () => URL.revokeObjectURL(url)
  }, [logo, name])

  return null
}
